import { stats } from '@/mocks/homeData';

export default function StatsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <p className="text-xs font-medium text-foreground-500 uppercase tracking-widest mb-3">
              平台实力
            </p>
            <p className="text-lg md:text-xl text-foreground-700 leading-relaxed max-w-2xl">
              每日黑料自上线以来，始终坚持"快、全、真"的内容理念，已累计发布爆料超过12,000条，其中超过3,000条经过多方验证。平台月活跃用户突破580万，爆料准确率高达98.6%，已成为中文互联网最具影响力的娱乐资讯平台之一。我们拥有一支由资深娱记、数据分析师和法律顾问组成的专业团队，确保每一条爆料都经过严格审核，为吃瓜群众提供最可靠的娱乐资讯。
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-10">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-1">
                  {stat.value}
                  <span className="text-primary-500">{stat.suffix}</span>
                </div>
                <p className="text-sm text-foreground-500">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}